import * as React from 'react';
import { observer } from 'mobx-react';
import { Box, IconButton, Modal, Typography } from '@mui/material';
import Pipelines from '../../Pipelines';
import DataStore from '../../../../../../store';
import Output from '../../../../../../components/Output';
import ProgressBar from '../../../../../../components/ProgressBar';
import { confirmDialogStore } from '../../../../../../store/ConfirmDialog';
import socketStore from '../../../../../../store/Socket';
import { SOCKET_USER_UPDATE_EVENT } from '../../../../../../constants/base';
import { structPipelineData } from '../../../../../../helpers/base';

const SearchPipelineModal = observer(
  ({
    open,
    handleClose,
    data = { pipelines: {} },
  }: {
    open: boolean;
    handleClose: any;
    data?: any;
  }) => {
    const [outputData, setOutputData] = React.useState<any>({});
    const [progress, setProgress] = React.useState(0);
    const [progressMax, setProgressMax] = React.useState(0);
    const [progressMessage, setProgressMessage] = React.useState('');

    React.useEffect(() => {
      const socket = socketStore.socket;
      const channel = SOCKET_USER_UPDATE_EVENT();

      if (socket) {
        socket.on(channel, (socketData) => {
          setProgress(socketData.progress);
          setProgressMax(socketData.total);
          setProgressMessage(socketData.message);
        });
      }
    }, [socketStore.socket]);

    const confirmRequest = async () => {
      confirmDialogStore.setIsProcessing(true);
      const resConfirm = await DataStore.pipelineLaunchRequest({
        confirm: true,
      });
      confirmDialogStore.setIsProcessing(false);
      if (resConfirm.messageType !== 'error') {
        if (resConfirm.response) {
          setOutputData({
            request: 'Pipeline launch',
            response: resConfirm,
            type: 'html',
          });
        }
      }
    };

    const disableRequest = async () => {
      confirmDialogStore.setIsProcessing(true);
      const resConfirm = await DataStore.pipelineLaunchRequest({
        confirm: false,
      });
      confirmDialogStore.setIsProcessing(false);
      if (resConfirm.messageType !== 'error') {
        if (resConfirm.response) {
          setOutputData({
            request: 'Pipeline launch',
            response: resConfirm,
            type: 'html',
          });
        }
      }
    };

    const preview = async (data: any) => {
      setProgress(0);
      setProgressMax(100);
      setProgressMessage('Starting...');
      const resData: any = await DataStore.pipelinePreviewRequest(data);
      if (resData) {
        setOutputData({
          request: 'Pipeline preview',
          response: resData,
          type: 'html',
        });
      }
      setProgressMessage('');
    };

    const launch = async (data: any) => {
      setProgress(0);
      setProgressMax(100);
      setProgressMessage('Starting...');
      const resData = await DataStore.pipelineLaunchRequest();
      if (resData) {
        if (resData.messageType === 'confirm') {
          confirmDialogStore.show(
            'Confirm job launch',
            resData.message,
            confirmRequest,
            disableRequest
          );
        } else {
          setOutputData({
            request: 'Pipeline launch',
            response: resData,
            type: 'html',
          });
        }
      }
      setProgressMessage('');
    };

    return (
      <Modal
        open={open}
        aria-labelledby='search-pipeline-modal-title'
        aria-describedby='search-pipeline-modal-description'
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
        }}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            width: { xs: '100%', sm: '80%', md: '70%', lg: '70%', xl: '70%' },
            maxWidth: 'xl',
            maxHeight: '90vh',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              position: 'sticky',
              top: 0,
              zIndex: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderBottom: '1px solid #ddd',
              backgroundColor: '#fff',
              px: 3,
              py: 2,
            }}
          >
            <Typography id='modal-title' variant='h6'>
              Pipelines
            </Typography>
            <IconButton
              onClick={() => {
                setOutputData({});
                handleClose();
              }}
            >
              x
            </IconButton>
          </Box>

          {/* Obsah */}
          <Box sx={{ p: 3, pb: 0 }}>
            <Pipelines
              disableSocket={true}
              preLoadData={structPipelineData(data)}
              customPreview={preview}
              customLaunch={launch}
              customProgressBar={() => {
                return (
                  <ProgressBar
                    actual={progress}
                    max={progressMax}
                    message={progressMessage}
                  />
                );
              }}
            />
          </Box>
          <Box sx={{ p: 3, pt: 0 }}>
            <Output data={outputData} />
          </Box>
        </Box>
      </Modal>
    );
  }
);
export default SearchPipelineModal;
